import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.upload-docs.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.upload-docs.description',
    defaultMessage: '',
  },
  uploadHeader: {
    id: 'cc4.form.upload-docs.upload-header',
    defaultMessage: 'Upload your flight documents',
  },
  isUploading: {
    id: 'cc4.form.upload-docs.uploading-message',
    defaultMessage: 'Uploading...',
  },
  modalMessage: {
    id: 'cc4.form.upload-docs.modal-message',
    defaultMessage: 'Delete this file?',
  },
  modalOnConfirm: {
    id: 'cc4.form.upload-docs.modal-on-confirm',
    defaultMessage: 'Delete',
  },
  modalOnCancel: {
    id: 'cc4.form.upload-docs.modal-on-cancel',
    defaultMessage: 'Cancel',
  },
  asideText: {
    id: 'cc4.form.upload-docs.aside-text',
    defaultMessage:
      "Tip: take a picture of your documents with your mobile and upload them. It's that simple!",
  },
  backButtonText: {
    id: 'cc4.form.upload-docs.back-button-text',
    defaultMessage: 'Back',
  },
  laterButtonText: {
    id: 'cc4.form.upload-docs.later-text',
    defaultMessage: "I'll do it later",
    description: 'Text on button to upload docs later',
  },
  submitButtonText: {
    id: 'cc4.form.upload-docs.submit-button-text',
    defaultMessage: 'Continue',
  },
});
